import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cc8f772"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = { class: "ion-text-center" }
const _hoisted_4 = {
  key: 1,
  class: "ion-text-center"
}
const _hoisted_5 = { class: "ion-text-center" }
const _hoisted_6 = {
  key: 2,
  class: "ion-text-center"
}
const _hoisted_7 = { class: "ion-text-center" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = {
  key: 0,
  class: "ion-padding-bottom"
}
const _hoisted_10 = {
  key: 1,
  class: "ion-padding-bottom"
}
const _hoisted_11 = { class: "ion-padding-bottom" }
const _hoisted_12 = {
  key: 2,
  class: "ion-padding-bottom"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "ion-padding-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_image_slides = _resolveComponent("image-slides")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.loading ? '...' : $setup.t('bookingDetails')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/bookings" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : _createCommentVNode("", true),
          (!$setup.loading && $setup.booking)
            ? (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, { class: "ion-text-center no-border-card" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, { style: {"padding-top":"0"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_chip, { class: "booking-code" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.booking.code), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_ion_badge, {
                                              class: "booking-status",
                                              color: "getBookingStatusColor(booking.status)"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString($setup.t(`BookingStatus.${$setup.booking.status}`)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_ion_icon, {
                                              icon: $setup.build,
                                              class: "build-icon"
                                            }, null, 8, ["icon"])
                                          ]),
                                          ($setup.booking.targetService)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.booking.targetService), 1))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_ion_card_subtitle, {
                                            class: "booking-date-time",
                                            style: {"padding":"0"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.formatDateString($setup.booking.date)) + " (" + _toDisplayString($setup.booking.selectedTimeRange) + ") ", 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("p", _hoisted_3, [
                                            ($setup.isPendingFinalPayment($setup.booking))
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 0,
                                                  class: "boxbox",
                                                  size: "large",
                                                  fill: "solid",
                                                  color: "success",
                                                  "router-link": `/checkout?bookingId=${$setup.booking.id}`
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.t('payNow')), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["router-link"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          ($setup.booking.receiptFileLink)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                                                _createVNode(_component_ion_button, {
                                                  class: "boxbox",
                                                  color: "success",
                                                  fill: "outline",
                                                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showBookingDoc($setup.booking, 'receipt'))),
                                                  disabled: $setup.downloadingReceipt
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.t('showReceipt')), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["disabled"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _withDirectives(_createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_ion_spinner)
                                          ], 512), [
                                            [_vShow, $setup.downloadingReceipt]
                                          ]),
                                          ($setup.booking.quotationFileLink)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                                ($setup.isBookingPendingDeposit($setup.booking))
                                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                                      key: 0,
                                                      class: "boxbox",
                                                      size: "large",
                                                      fill: "solid",
                                                      color: "success",
                                                      "router-link": `/checkout?bookingId=${$setup.booking.id}`
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.t('payDeposit')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["router-link"]))
                                                  : (_openBlock(), _createBlock(_component_ion_button, {
                                                      key: 1,
                                                      class: "boxbox",
                                                      fill: "outline",
                                                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showBookingDoc($setup.booking, 'quotation'))),
                                                      disabled: $setup.downloadingQuotation
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString($setup.t('showQuotation')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["disabled"]))
                                              ]))
                                            : _createCommentVNode("", true),
                                          _withDirectives(_createElementVNode("div", _hoisted_7, [
                                            _createVNode(_component_ion_spinner)
                                          ], 512), [
                                            [_vShow, $setup.downloadingQuotation]
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_8, [
                                            ($setup.booking.targetService)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                                  _createVNode(_component_ion_icon, {
                                                    icon: $setup.today,
                                                    class: "info-icon"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('bookedServices')) + _toDisplayString($setup.booking.targetService), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            ($setup.booking.serviceFee != '')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                                  _createVNode(_component_ion_icon, {
                                                    icon: $setup.card,
                                                    class: "info-icon"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('serviceFee')) + "HK$" + _toDisplayString($setup.numberWithCommas($setup.booking.serviceFee)), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("p", _hoisted_11, [
                                              _createVNode(_component_ion_icon, {
                                                icon: $setup.home,
                                                class: "info-icon"
                                              }, null, 8, ["icon"]),
                                              _createTextVNode(" " + _toDisplayString($setup.t('address')) + "：" + _toDisplayString($setup.booking.address), 1)
                                            ]),
                                            ($setup.booking.customerNote)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                                  _createVNode(_component_ion_icon, {
                                                    icon: $setup.person,
                                                    class: "info-icon"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('customerNote')) + "：" + _toDisplayString($setup.booking.customerNote), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (!$setup.isBookingCompleted($setup.booking))
                                            ? (_openBlock(), _createBlock(_component_ion_card, {
                                                key: 0,
                                                class: "big-box",
                                                button: "",
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.showBookingQRCode($setup.booking)), ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    icon: $setup.qrCodeOutline,
                                                    class: "qr-code"
                                                  }, null, 8, ["icon"]),
                                                  _hoisted_13,
                                                  _createElementVNode("p", null, _toDisplayString($setup.t('bookingQRCode')), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_image_slides, {
                                            class: "ion-margin-bottom",
                                            listHeader: $setup.t('clientPhotos'),
                                            imageLinks: $setup.booking.clientPhotoLinks
                                          }, null, 8, ["listHeader", "imageLinks"]),
                                          _createVNode(_component_image_slides, {
                                            class: "ion-margin-bottom",
                                            listHeader: $setup.t('beforeService'),
                                            imageLinks: $setup.booking.beforePhotoLinks
                                          }, null, 8, ["listHeader", "imageLinks"]),
                                          _createVNode(_component_image_slides, {
                                            class: "ion-margin-bottom",
                                            listHeader: $setup.t('afterService'),
                                            imageLinks: $setup.booking.afterPhotoLinks
                                          }, null, 8, ["listHeader", "imageLinks"]),
                                          _createElementVNode("p", _hoisted_14, [
                                            _createElementVNode("small", null, _toDisplayString($setup.t('PostPage.lastUpdated')) + _toDisplayString($setup.formatDate($setup.booking.updatedAt)), 1)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}